import { get } from "lodash";
import log from "loglevel";
import * as t from "types";

export const getGlobalMessageReducerResponse = (
  state: any
): string | undefined => {
  log.info("Getting GlobalMessage from Store...");
  const value = get(state, `globalMessage.response`);
  return value;
};
